'use client';

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultSendIcon = /*#__PURE__*/React.memo(function DefaultSendIcon() {
  return /*#__PURE__*/_jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    style: {
      width: '1em',
      height: '1em'
    },
    children: /*#__PURE__*/_jsx("path", {
      d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
    })
  });
});
if (process.env.NODE_ENV !== "production") DefaultSendIcon.displayName = "DefaultSendIcon";
export default DefaultSendIcon;